import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Wrench } from "lucide-react";

interface NeedsServiceBlockedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trailerId: string;
  reason: string | null;
}

/**
 * Hard block dialog shown when a dispatcher tries to assign a trailer
 * flagged "Needs Service" during AYMS check-in. Single dismiss action —
 * the trailer assignment is not applied to the order form.
 */
export function NeedsServiceBlockedDialog({
  open,
  onOpenChange,
  trailerId,
  reason,
}: NeedsServiceBlockedDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Wrench className="h-5 w-5 text-destructive" />
            Trailer cannot be assigned
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                Trailer{" "}
                <strong className="text-foreground font-mono">{trailerId}</strong>{" "}
                is marked <strong className="text-foreground">"Needs Service"</strong>{" "}
                and cannot be assigned to an order.
              </p>
              {reason && reason.trim().length > 0 ? (
                <div className="rounded-md border border-destructive/40 bg-destructive/5 p-3">
                  <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground mb-1">
                    Reported issue
                  </p>
                  <p className="text-sm text-foreground whitespace-pre-wrap">
                    {reason}
                  </p>
                </div>
              ) : (
                <p className="text-sm text-muted-foreground">
                  No reason was recorded at check-in.
                </p>
              )}
              <p className="text-xs text-muted-foreground">
                Check the trailer in again without the "Needs Service" flag to
                clear it.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => onOpenChange(false)}>OK</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}